const router = [
  {
    path: "/assessmentrules",
    name: "AssessmentRules",
    meta: { title: "考核细则" },
    component: () => import("@/views/assessmentScore/AssessmentRules.vue"),
  },
  {
    path: "/assessmentrules/add",
    name: "AssessmentRules",
    meta: { title: "新增考核细则", activeMenu: "/assessmentrules" },
    component: () => import("@/views/assessmentScore/AssessmentRulesAdd.vue"),
  },
  {
    path: "/assessmentrules/edit",
    name: "AssessmentRules",
    meta: { title: "编辑考核细则", activeMenu: "/assessmentrules" },
    component: () => import("@/views/assessmentScore/AssessmentRulesAdd.vue"),
  },
  {
    path: "/assessmentworkorder",
    name: "AssessmentWorkOrder",
    meta: { title: "考核工单" },
    component: () => import("@/views/assessmentScore/AssessmentWorkOrder.vue"),
  },
  {
    path: "/assessmentresults",
    name: "AssessmentResults",
    meta: { title: "考核结果" },
    component: () => import("@/views/assessmentScore/AssessmentResults.vue"),
  },
  {
    path: "/assessmentresults/add",
    name: "AssessmentResultsAdd",
    meta: { title: "新增考核结果", activeMenu: "/assessmentresults" },
    component: () => import("@/views/assessmentScore/AssessmentResultsAdd.vue"),
  },
  {
    path: "/assessmentresults/detail",
    name: "AssessmentResultsDetail",
    meta: { title: "考核结果详情", activeMenu: "/assessmentresults" },
    component: () =>
      import("@/views/assessmentScore/AssessmentResultsDetail.vue"),
  },
];
export default router;
